import { createContext, useContext } from 'react';

export const FooterSlotContext = createContext<HTMLElement | undefined>(undefined);

export function useFooterSlot(): HTMLElement | undefined {
    return useContext(FooterSlotContext);
}
